var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "global-map-area promo-box no-margin parallax",
        attrs: { "data-stellar-background-ratio": "0.5" },
      },
      [
        _c("div", { staticClass: "container" }, [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.bremen-airport.com/service/anreise-parken/parkplatz-onlinebuchung/parkplatzbuchung/",
                target: "_blank",
              },
            },
            [
              _c("div", { staticClass: "image-container" }, [
                _c("img", {
                  staticClass: "animated",
                  attrs: {
                    src: "/res/images/shared/promo_bremen.jpg",
                    alt: "",
                    width: "",
                    height: "370",
                    "data-animation-type": "fadeInUp",
                  },
                }),
              ]),
            ]
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }